module.exports = __webpack_public_path__ + "img/arrow-left-white.9806e220.svg";